<template>
    <transition name="modal-fade">
        <div class="modal-backdrop">
            <div class="modal" v-click-outside="close">
                <slot name="header">
                    <div class="modal-header">
                        <h2 class="title">{{ title }}</h2>
                        <button @click="close" class="btn-close">
                            <i style="font-size: 25px" class="material-icons"
                                >close</i
                            >
                        </button>
                    </div>
                </slot>

                <slot name="body" v-if="data">
                    <div class="modal-body">
                        <div style="display: flex; width: 100%">
                            <label style="color: #595959;">Código</label>
                        </div>
                        <input
                            class="modal-input"
                            placeholder="Código"
                            style="margin-top: 7px;"
                            v-model="data.codigo"
                        />
                        <div style="display: flex;">
                            <label style="color: #595959;">Nível</label>
                        </div>
                        <input
                            class="modal-input"
                            placeholder="Nível"
                            style="margin-top: 7px;"
                            v-model="data.nivel"
                        />
                        <div style="display: flex;">
                            <label style="color: #595959;"
                                >Superior Imediato</label
                            >
                        </div>
                        <input
                            class="modal-input"
                            placeholder="Superior Imediato"
                            style="margin-top: 7px;"
                            v-model="data.superior"
                        />

                        <div style="display: flex;">
                            <label style="color: #595959;"
                                >Data de Efetivação</label
                            >
                        </div>
                        <input
                            type="date"
                            class="modal-input"
                            placeholder="Data de Efetivação"
                            style="margin-top: 7px;"
                            v-model="data.data_efetivacao"
                        />
                        <div style="display: flex;">
                            <label style="color: #595959;"
                                >Data de Atualização</label
                            >
                        </div>
                        <input
                            type="date"
                            class="modal-input"
                            placeholder="Data de Atualização"
                            style="margin-top: 7px;"
                            v-model="data.data_atualizacao"
                        />
                        <div style="display: flex;">
                            <label style="color: #595959;"
                                >Data de Desvinculação</label
                            >
                        </div>
                        <input
                            type="date"
                            class="modal-input"
                            placeholder="Data de Desvinculação"
                            style="margin-top: 7px;"
                            v-model="data.data_desvinculacao"
                        />
                        <textarea
                            class="modal-input"
                            rows="120"
                            cols="50"
                            placeholder="Digite as observaçoes necessárias"
                            v-model="data.observacao"
                        ></textarea>
                    </div>
                </slot>

                <slot name="footer">
                    <div class="modal-footer">
                        <button
                            class="action-button cancel-button"
                            v-show="alreadyLinked && hasAdminPermission"
                            @click="onCancel"
                        >
                            Excluir Seguradora
                        </button>
                        <!-- <button class="action-button" @click="onSendForm">
                            Enviar Formulário
                        </button> -->
                        <button class="action-button" @click="onConfirm">
                            {{
                                alreadyLinked
                                    ? "Atualizar Seguradora"
                                    : "Adicionar Seguradora"
                            }}
                        </button>
                    </div>
                </slot>
            </div>
        </div>
    </transition>
</template>

<script>
import Vue from "vue";

Vue.directive("click-outside", {
    bind: function(el, binding, vnode) {
        el.eventSetDrag = function() {
            el.setAttribute("data-dragging", "yes");
        };
        el.eventClearDrag = function() {
            el.removeAttribute("data-dragging");
        };
        el.eventOnClick = function(event) {
            var dragging = el.getAttribute("data-dragging");
            // Check that the click was outside the el and its children, and wasn't a drag
            if (
                !(el == event.target || el.contains(event.target)) &&
                !dragging
            ) {
                // call method provided in attribute value
                vnode.context[binding.expression](event);
            }
        };
        document.addEventListener("touchstart", el.eventClearDrag);
        document.addEventListener("touchmove", el.eventSetDrag);
        document.addEventListener("click", el.eventOnClick);
        document.addEventListener("touchend", el.eventOnClick);
    },
    unbind: function(el) {
        document.removeEventListener("touchstart", el.eventClearDrag);
        document.removeEventListener("touchmove", el.eventSetDrag);
        document.removeEventListener("click", el.eventOnClick);
        document.removeEventListener("touchend", el.eventOnClick);
        el.removeAttribute("data-dragging");
    }
});

export default {
    name: "InsuranceModal",
    props: {
        title: String,
        hasAdminPermission: Boolean,
        data: Object,
        alreadyLinked: Boolean
    },
    methods: {
        close() {
            this.$emit("close");
        },
        onClickOutside() {
            this.close();
        },
        onConfirm() {
            this.$emit("confirm", this.data);
        },
        onCancel() {
            this.$emit("cancel", this.data);
        },
        onSendForm() {
            this.$emit("sendForm", this.data);
        }
    }
};
</script>

<style>
.modal-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

.modal {
    background: #ffffff;
    display: flex;
    flex-direction: column;
    border-radius: 5px;
    width: 37rem;
    max-height: 80%;
}

.title {
    color: #545454;
    font-size: 1.875em;
    font-weight: 600;
    text-transform: none;
    word-wrap: break-word;
}

.modal-header {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    padding: 22.5px 28px 0;
}

.modal-body {
    position: relative;
    padding: 0 25px;
    margin-bottom: 20px;
}

.btn-close {
    position: absolute;
    top: 10px;
    right: 6px;
    border: none;
    font-size: 20px;
    cursor: pointer;
    font-weight: bold;
    color: #545454;
    background: transparent;
}

.btn-close:hover {
    background-color: transparent;
}

.modal-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 25px !important;
    margin-bottom: 20px;
}

.action-button {
    border: 0;
    border-radius: 0.25em;
    background: initial;
    background-color: #7066e0;
    color: #fff;
    font-size: 1em;
    padding: 0.625em 1.1em;
    display: inline-block;
    font-weight: 500;
}

.action-button:hover {
    background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1));
}

.action-button:focus {
    background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1));
    background-color: #7066e0;
}

.cancel-button {
    background-color: #f44;
}

.modal-fade-enter,
.modal-fade-leave-to {
    opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
    transition: opacity 0.5s ease;
}
</style>



// WEBPACK FOOTER //
// src/components/empresas/components/InsuranceModal.vue